import { transparentize } from '../../../../utils/color';
import { asMultiStyleConfig } from '../../../../utils/theme';
export var DetailsCard = asMultiStyleConfig({
  parts: ['container', 'header', 'footer', 'body'],
  defaultProps: {
    colorScheme: 'idle'
  },
  baseStyle: {
    container: {
      boxSizing: 'border-box',
      border: '1px',
      borderColor: '#cccccc',
      boxShadow: 'none',
      position: 'relative'
    },
    header: {
      display: 'flex',
      p: 4
    },
    body: {
      pl: 4,
      pr: 4,
      pb: 4
    },
    footer: {
      p: 4
    }
  },
  colorSchemes: {
    idle: {
      container: {
        backgroundColor: 'white'
      },
      footer: {
        bg: 'grey.280'
      }
    },
    focus: {
      container: {
        bg: 'blue.1140',
        borderColor: '#57A7DA'
      },
      footer: {
        bg: 'blue.1140'
      }
    },
    success: {
      container: {
        bg: transparentize('#01B723', 0.15)
      },
      footer: {
        bg: '#CAE5CF'
      }
    },
    pending: {
      container: {
        bg: transparentize('#FF8000', 0.15)
      },
      footer: {
        bg: '#F0DDCA'
      }
    }
  }
});